module.exports = "<div id=\"wrapper\">\n  <div id=\"wrapper-text\">{{text}}</div>\n  <div id=\"wrapper-button\" (click)=\"close.emit()\">\n    <img src=\"assets/electraAssets/clearGrey.svg\"/>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/electraLib/component/subPageHeader/subPageHeader.component.html
// module id = 437
// module chunks = 1